import React, { useCallback, useState } from 'react'
import classNames from 'classnames'
import { Env } from '@dcl/ui-env'
import { t } from 'decentraland-dapps/dist/modules/translation/utils'
import { Loader } from 'decentraland-ui/dist/components/Loader/Loader'
import { useTabletAndBelowMediaQuery } from 'decentraland-ui/dist/components/Media/Media'
import { WearablePreview } from 'decentraland-ui/dist/components/WearablePreview/WearablePreview'
import { JumpIn } from 'decentraland-ui2'
import { config } from '../../modules/config'
import { View } from '../../utils/view'
import { Props } from './Avatar.types'
import styles from './Avatar.module.css'

const Avatar = (props: Props) => {
  const { profile, profileAddress, view, isUnityWearablePreviewEnabled } = props

  const [isLoadingWearablePreview, setIsLoadingWearablePreview] = useState(true)
  const [isError, setIsError] = useState(false)

  const isTabletAndBelow = useTabletAndBelowMediaQuery()

  const handleOnLoad = useCallback(() => {
    setIsLoadingWearablePreview(false)
  }, [setIsLoadingWearablePreview])

  const handleError = useCallback(() => {
    setIsLoadingWearablePreview(false)
    setIsError(true)
  }, [setIsLoadingWearablePreview])

  return (
    <div className={classNames(styles.Avatar, { [styles.loading]: isLoadingWearablePreview, [styles.noProfile]: !profile })}>
      {isLoadingWearablePreview ? (
        <div className={styles.loaderOverlay}>
          <Loader active inline size="huge" />
        </div>
      ) : null}
      {!isError ? (
        <div className={styles.wearablePreview}>
          <WearablePreview
            baseUrl={config.get('WEARABLE_PREVIEW_URL')}
            dev={config.getEnv() === Env.DEVELOPMENT}
            disableBackground={true}
            disableDefaultWearables
            lockBeta={true}
            panning={false}
            profile={profileAddress}
            unity={!!isUnityWearablePreviewEnabled}
            unityMode="profile"
            onError={handleError}
            onLoad={handleOnLoad}
          />
        </div>
      ) : null}
      {(!profile && view === View.OWN && !isLoadingWearablePreview) || isError ? (
        <div data-testid="avatar-message" className={styles.message}>
          {t('avatar.message')}
        </div>
      ) : null}
      {view === View.OWN && (
        <div className={styles.editButton}>
          <JumpIn
            variant="button"
            buttonText={isTabletAndBelow ? undefined : t('avatar.edit')}
            hideIcon={false}
            modalProps={{
              title: t('avatar.download_modal_title'),
              description: t('avatar.download_modal_description'),
              buttonLabel: t('avatar.download_modal_button_label')
            }}
          />
        </div>
      )}
    </div>
  )
}

export default Avatar
